import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { submissionsApi } from "../../../utils";
import { ActivityTypeEnumText } from "../../lms-shared/models/ActivityTypeEnum";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { useDispatch, useSelector } from "react-redux";
import * as PathRouter from '../../../models/PathRoute'
import { SubmissionStateTypeTextEnum } from "../../lms-shared/models/SubmissionStateTypeEnum";
import { changeActiveLessonId } from "../../../store/general-actions";

const MyProject = () => {

    const { lessonId, studyGroupId } = useParams();
    const [searchParams] = useSearchParams();
    const { user } = useSelector(state => state.auth);
    const assessmentExternalId = searchParams?.get("id")
    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (lessonId && studyGroupId && homeUrl && user.id) {
            const url = `${homeUrl}/${studyGroupId}/${PathRouter.PROJECT}/`;

            const submissionsProjectFilter = {
                lessonId: lessonId,
                activityType: assessmentExternalId ? ActivityTypeEnumText.Learning : ActivityTypeEnumText.Final,
                assessmentExternalId: assessmentExternalId
            }
            submissionsApi.submissionsFilterProjectPost({ submissionsProjectFilter }, (error, resdata, response) => {
                if (error)
                    dispatch(throwApiError({ userMessage: texts.MessageContentSubmissionsFilterRange, error: error, statusCode: response?.statusCode, message: "submissionsFilterProjectPost " + error.message, level: 2, component: "LessonViewerTabs", line: 66 }))
                else {
                    if (resdata.id) {
                        navigateWithState(url + resdata.projectId);
                    }
                    else {
                        const submissionAddInput = {
                            assessmentId: resdata.assessmentId,
                            submissionStatus: SubmissionStateTypeTextEnum.Started,
                            studyGroupId,
                        }

                        dispatch(changeActiveLessonId(lessonId, studyGroupId, null, [user.id]));

                        submissionsApi.submissionsAddPost({ submissionAddInput }, (submissionsError, submissionsResdata, submissionsResponse) => {
                            if (!submissionsError) {
                                navigateWithState(url + submissionsResdata.submission?.project?.id);
                            }
                        })
                    }
                }
            })
        }
    }, [lessonId, studyGroupId, homeUrl, user])

    const navigateWithState = (url, lessonParticipant) => {
        navigate(`${url}`, { state: { prevPath: window.location.pathname, replace: true, lessonParticipant: lessonParticipant } })
    }

    return (
        <></>
    )
}
export default MyProject